<template>
	<div class="ld-skeleton" :class="'is-' + variant" aria-hidden="true">
		<div v-if="withHero" class="ld-sk-hero">
			<span class="ld-sk ld-sk-title"></span>
			<span class="ld-sk ld-sk-subtitle"></span>
		</div>

		<template v-if="variant === 'cards'">
			<div class="ld-sk-grid">
				<div class="ld-sk-card" v-for="n in count" :key="'c-' + n">
					<span class="ld-sk ld-sk-cover"></span>
					<div class="ld-sk-card-body">
						<span class="ld-sk" style="width: 72%; height: 14px"></span>
						<span class="ld-sk" style="width: 44%; height: 12px; margin-top: 10px"></span>
						<span class="ld-sk ld-sk-btn"></span>
					</div>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'list'">
			<div class="ld-sk-list">
				<div class="ld-sk-row" v-for="n in count" :key="'r-' + n">
					<span v-if="withAvatar" class="ld-sk ld-sk-circle"></span>
					<div class="ld-sk-row-text">
						<span class="ld-sk" :style="{ width: rowTitleWidth(n), height: '14px' }"></span>
						<span class="ld-sk" :style="{ width: rowSubWidth(n), height: '10px', marginTop: '8px' }"></span>
					</div>
					<span class="ld-sk" style="width: 64px; height: 14px; flex-shrink: 0"></span>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'table'">
			<div class="ld-sk-table">
				<div class="ld-sk-thead">
					<span class="ld-sk" style="width: 72px; height: 10px"></span>
					<span class="ld-sk" style="width: 56px; height: 10px"></span>
					<span class="ld-sk" style="width: 64px; height: 10px"></span>
					<span class="ld-sk" style="width: 48px; height: 10px"></span>
				</div>
				<div class="ld-sk-trow" v-for="n in count" :key="'t-' + n">
					<div class="ld-sk-asset">
						<span class="ld-sk ld-sk-circle"></span>
						<div>
							<span class="ld-sk" style="width: 88px; height: 14px; display: block"></span>
							<span class="ld-sk" style="width: 52px; height: 10px; margin-top: 8px; display: block"></span>
						</div>
					</div>
					<span class="ld-sk" style="width: 56px; height: 14px"></span>
					<span class="ld-sk" style="width: 72px; height: 14px"></span>
					<span class="ld-sk" style="width: 48px; height: 14px"></span>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'form'">
			<div class="ld-sk-card-block">
				<span class="ld-sk" style="width: 80px; height: 12px"></span>
				<span class="ld-sk" style="width: 160px; height: 28px; margin-top: 12px"></span>
			</div>
			<div class="ld-sk-card-block">
				<div class="ld-sk-chips">
					<span class="ld-sk ld-sk-chip" v-for="n in 4" :key="'chip-' + n"></span>
				</div>
				<span class="ld-sk" style="width: 100%; height: 48px; margin-top: 16px; border-radius: 14px"></span>
				<span class="ld-sk" style="width: 100%; height: 48px; margin-top: 12px; border-radius: 14px"></span>
				<span class="ld-sk" style="width: 70%; height: 12px; margin-top: 16px"></span>
				<span class="ld-sk ld-sk-cta"></span>
			</div>
			<div v-if="withList" class="ld-sk-card-block">
				<span class="ld-sk" style="width: 100px; height: 12px; margin-bottom: 16px"></span>
				<div class="ld-sk-row" v-for="n in Math.min(count, 4)" :key="'fr-' + n">
					<div class="ld-sk-row-text">
						<span class="ld-sk" style="width: 46%; height: 14px"></span>
						<span class="ld-sk" style="width: 30%; height: 10px; margin-top: 8px"></span>
					</div>
					<span class="ld-sk" style="width: 56px; height: 14px"></span>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'profile'">
			<div class="ld-sk-card-block">
				<span class="ld-sk" style="width: 72px; height: 12px"></span>
				<span class="ld-sk" style="width: 180px; height: 28px; margin-top: 12px"></span>
				<div class="ld-sk-row" style="margin-top: 16px" v-for="n in 3" :key="'pr-' + n">
					<span class="ld-sk" style="width: 80px; height: 12px"></span>
					<span class="ld-sk" style="width: 96px; height: 12px"></span>
				</div>
				<div class="ld-sk-actions">
					<span class="ld-sk ld-sk-btn"></span>
					<span class="ld-sk ld-sk-btn"></span>
				</div>
			</div>
			<div class="ld-sk-card-block">
				<div class="ld-sk-row" v-for="n in count" :key="'pl-' + n">
					<div class="ld-sk-row-text">
						<span class="ld-sk" :style="{ width: rowTitleWidth(n), height: '14px' }"></span>
						<span class="ld-sk" :style="{ width: rowSubWidth(n), height: '10px', marginTop: '8px' }"></span>
					</div>
					<span class="ld-sk" style="width: 56px; height: 14px"></span>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'detail'">
			<div class="ld-sk-hero-row">
				<span class="ld-sk ld-sk-circle lg"></span>
				<div>
					<span class="ld-sk" style="width: 140px; height: 22px; display: block"></span>
					<span class="ld-sk" style="width: 88px; height: 12px; margin-top: 10px; display: block"></span>
				</div>
			</div>
			<div class="ld-sk-metrics">
				<div class="ld-sk-metric" v-for="n in 3" :key="'m-' + n">
					<span class="ld-sk" style="width: 72px; height: 10px"></span>
					<span class="ld-sk" style="width: 110px; height: 18px; margin-top: 8px"></span>
					<span class="ld-sk" style="width: 64px; height: 10px; margin-top: 8px"></span>
				</div>
			</div>
			<div class="ld-sk-card-block">
				<span class="ld-sk" style="width: 100px; height: 16px"></span>
				<div class="ld-sk-stat-grid">
					<div v-for="n in 6" :key="'s-' + n">
						<span class="ld-sk" style="width: 56px; height: 10px; display: block"></span>
						<span class="ld-sk" style="width: 80px; height: 16px; margin-top: 8px; display: block"></span>
					</div>
				</div>
				<span v-if="withChart" class="ld-sk" style="width: 100%; height: 180px; margin-top: 16px; border-radius: 12px"></span>
			</div>
			<div class="ld-sk-card-block">
				<span class="ld-sk" style="width: 88px; height: 16px"></span>
				<div class="ld-sk-stat-grid">
					<div v-for="n in 6" :key="'b-' + n">
						<span class="ld-sk" style="width: 56px; height: 10px; display: block"></span>
						<span class="ld-sk" style="width: 80px; height: 16px; margin-top: 8px; display: block"></span>
					</div>
				</div>
			</div>
			<span v-if="withCta" class="ld-sk ld-sk-cta"></span>
		</template>

		<template v-else-if="variant === 'article'">
			<span class="ld-sk" style="width: 56%; height: 22px"></span>
			<span class="ld-sk" style="width: 100%; height: 12px; margin-top: 20px"></span>
			<span class="ld-sk" style="width: 94%; height: 12px; margin-top: 10px"></span>
			<span class="ld-sk" style="width: 88%; height: 12px; margin-top: 10px"></span>
			<span class="ld-sk" style="width: 100%; height: 12px; margin-top: 10px"></span>
			<span class="ld-sk" style="width: 70%; height: 12px; margin-top: 10px"></span>
			<span class="ld-sk" style="width: 100%; height: 160px; margin-top: 24px; border-radius: 12px"></span>
			<span class="ld-sk" style="width: 100%; height: 12px; margin-top: 24px"></span>
			<span class="ld-sk" style="width: 90%; height: 12px; margin-top: 10px"></span>
			<span class="ld-sk" style="width: 76%; height: 12px; margin-top: 10px"></span>
		</template>

		<template v-else-if="variant === 'kline'">
			<div class="ld-sk-kline">
				<div class="ld-sk-kline-plot">
					<div class="ld-sk-kline-candles">
						<span
							v-for="n in klineBarCount"
							:key="'kc-' + n"
							class="ld-sk-kline-col"
							:style="klineColStyle(n)"
						>
							<span class="ld-sk ld-sk-kline-wick"></span>
							<span class="ld-sk ld-sk-kline-body" :style="klineBodyStyle(n)"></span>
						</span>
					</div>
					<div class="ld-sk-kline-axis">
						<span class="ld-sk" v-for="n in 4" :key="'ka-' + n"></span>
					</div>
				</div>
				<div class="ld-sk-kline-vol">
					<span
						v-for="n in klineBarCount"
						:key="'kv-' + n"
						class="ld-sk ld-sk-kline-vol-bar"
						:style="klineVolStyle(n)"
					></span>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'sheet'">
			<span class="ld-sk" style="width: 140px; height: 18px; margin: 0 auto 20px"></span>
			<div class="ld-sk-row" v-for="n in count" :key="'sh-' + n">
				<span class="ld-sk" style="width: 80px; height: 12px"></span>
				<span class="ld-sk" style="width: 96px; height: 12px"></span>
			</div>
			<span class="ld-sk ld-sk-cta" style="margin-top: 20px"></span>
			<span class="ld-sk" style="width: 100%; height: 44px; margin-top: 10px; border-radius: 999px"></span>
		</template>

		<template v-else-if="variant === 'trade'">
			<div class="ld-sk-trade">
				<div class="ld-sk-trade-hero">
					<div class="ld-sk-trade-crumb">
						<span class="ld-sk" style="width: 56px; height: 12px"></span>
						<span class="ld-sk" style="width: 8px; height: 12px"></span>
						<span class="ld-sk" style="width: 72px; height: 12px"></span>
					</div>
					<div class="ld-sk-trade-asset">
						<div class="ld-sk-hero-row">
							<span class="ld-sk ld-sk-circle ld-sk-trade-logo"></span>
							<div>
								<span class="ld-sk" style="width: 160px; height: 28px; display: block"></span>
								<span class="ld-sk" style="width: 72px; height: 12px; margin-top: 6px; display: block"></span>
							</div>
						</div>
						<span class="ld-sk ld-sk-circle ld-sk-trade-collect"></span>
					</div>
					<div class="ld-sk-trade-price">
						<span class="ld-sk" style="width: 220px; height: 36px"></span>
						<span class="ld-sk" style="width: 72px; height: 16px"></span>
					</div>
				</div>
				<div class="ld-sk-trade-layout">
					<div class="ld-sk-card-block ld-sk-trade-chart">
						<div class="ld-sk-chips">
							<span class="ld-sk ld-sk-chip ld-sk-trade-chip" v-for="n in 6" :key="'tc-' + n"></span>
						</div>
						<div class="ld-sk-trade-kline">
							<LdSkeleton variant="kline" />
						</div>
					</div>
					<div class="ld-sk-card-block ld-sk-trade-form">
						<div class="ld-sk-trade-seg">
							<span class="ld-sk ld-sk-trade-seg-item"></span>
							<span class="ld-sk ld-sk-trade-seg-item"></span>
						</div>
						<div class="ld-sk-trade-toolbar">
							<div class="ld-sk-trade-tabs ld-sk-trade-tabs--sub">
								<span class="ld-sk" style="height: 14px; width: 36px"></span>
								<span class="ld-sk" style="height: 14px; width: 36px"></span>
							</div>
							<span class="ld-sk ld-sk-trade-lev-pill"></span>
						</div>
						<span class="ld-sk" style="width: 64px; height: 12px; margin-top: 4px"></span>
						<span class="ld-sk ld-sk-trade-field"></span>
						<span class="ld-sk" style="width: 48px; height: 12px; margin-top: 16px"></span>
						<span class="ld-sk ld-sk-trade-field"></span>
						<div class="ld-sk-trade-switch">
							<span class="ld-sk" style="width: 72px; height: 12px"></span>
							<span class="ld-sk ld-sk-trade-switch-track"></span>
						</div>
						<div class="ld-sk-trade-switch">
							<span class="ld-sk" style="width: 64px; height: 12px"></span>
							<span class="ld-sk ld-sk-trade-switch-track"></span>
						</div>
						<div class="ld-sk-trade-meta">
							<div class="ld-sk-row" v-for="n in 5" :key="'tm-' + n" style="padding: 10px 0">
								<span class="ld-sk" style="width: 88px; height: 12px"></span>
								<span class="ld-sk" style="width: 72px; height: 12px"></span>
							</div>
						</div>
						<div class="ld-sk-actions ld-sk-trade-actions">
							<span class="ld-sk ld-sk-btn ld-sk-trade-action"></span>
							<span class="ld-sk ld-sk-btn ld-sk-trade-action"></span>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'pools'">
			<div class="ld-sk-card-block">
				<div class="ld-sk-hero-row">
					<span class="ld-sk ld-sk-circle"></span>
					<div>
						<span class="ld-sk" style="width: 100px; height: 14px; display: block"></span>
						<span class="ld-sk" style="width: 64px; height: 10px; margin-top: 8px; display: block"></span>
					</div>
				</div>
				<div class="ld-sk-row" v-for="n in 4" :key="'pool-' + n" style="margin-top: 12px">
					<span class="ld-sk" style="width: 90px; height: 12px"></span>
					<span class="ld-sk" style="width: 110px; height: 12px"></span>
				</div>
			</div>
			<div class="ld-sk-featured">
				<div class="ld-sk-feat-card" v-for="n in 3" :key="'ft-' + n">
					<div class="ld-sk-hero-row">
						<span class="ld-sk ld-sk-circle"></span>
						<div>
							<span class="ld-sk" style="width: 72px; height: 12px; display: block"></span>
							<span class="ld-sk" style="width: 48px; height: 10px; margin-top: 8px; display: block"></span>
						</div>
					</div>
					<span class="ld-sk" style="width: 100%; height: 56px; margin-top: 16px; border-radius: 8px"></span>
				</div>
			</div>
			<div class="ld-sk-table" style="margin-top: 8px">
				<div class="ld-sk-trow" v-for="n in count" :key="'pt-' + n">
					<div class="ld-sk-asset">
						<span class="ld-sk ld-sk-circle"></span>
						<div>
							<span class="ld-sk" style="width: 88px; height: 14px; display: block"></span>
							<span class="ld-sk" style="width: 52px; height: 10px; margin-top: 8px; display: block"></span>
						</div>
					</div>
					<span class="ld-sk" style="width: 56px; height: 14px"></span>
					<span class="ld-sk" style="width: 72px; height: 14px"></span>
				</div>
			</div>
		</template>

		<template v-else-if="variant === 'chat'">
			<div class="ld-sk-chat" v-for="n in count" :key="'ch-' + n" :class="{ mine: n % 2 === 0 }">
				<span class="ld-sk ld-sk-bubble" :style="{ width: chatWidth(n) }"></span>
			</div>
		</template>

		<template v-else-if="variant === 'landing'">
			<div class="ld-sk-landing-hero">
				<div>
					<span class="ld-sk" style="width: 72px; height: 12px"></span>
					<span class="ld-sk" style="width: 80%; height: 36px; margin-top: 16px"></span>
					<span class="ld-sk" style="width: 70%; height: 14px; margin-top: 14px"></span>
					<div class="ld-sk-actions" style="margin-top: 24px">
						<span class="ld-sk ld-sk-cta" style="width: 140px; margin: 0"></span>
						<span class="ld-sk" style="width: 140px; height: 48px; border-radius: 999px"></span>
					</div>
				</div>
				<span class="ld-sk ld-sk-visual"></span>
			</div>
			<div class="ld-sk-landing-stats">
				<div class="ld-sk-metric" v-for="n in 4" :key="'ls-' + n">
					<span class="ld-sk" style="width: 48%; height: 18px"></span>
					<span class="ld-sk" style="width: 36%; height: 10px; margin-top: 8px"></span>
				</div>
			</div>
			<div class="ld-sk-landing-featured">
				<div class="ld-sk-card" v-for="n in 2" :key="'lf-' + n">
					<span class="ld-sk ld-sk-cover ld-sk-cover-lg"></span>
					<div class="ld-sk-card-body">
						<span class="ld-sk" style="width: 44%; height: 14px"></span>
						<span class="ld-sk" style="width: 86%; height: 10px; margin-top: 10px"></span>
					</div>
				</div>
			</div>
			<div class="ld-sk-grid ld-sk-landing-markets">
				<div class="ld-sk-card" v-for="n in 4" :key="'ld-' + n">
					<span class="ld-sk ld-sk-cover"></span>
					<div class="ld-sk-card-body">
						<span class="ld-sk" style="width: 60%; height: 14px"></span>
						<span class="ld-sk" style="width: 90%; height: 10px; margin-top: 10px"></span>
					</div>
				</div>
			</div>
			<div class="ld-sk-landing-split">
				<div class="ld-sk-card-body">
					<span class="ld-sk" style="width: 28%; height: 10px"></span>
					<span class="ld-sk" style="width: 72%; height: 18px; margin-top: 10px"></span>
					<span class="ld-sk" style="width: 90%; height: 10px; margin-top: 12px"></span>
					<span class="ld-sk" style="width: 84%; height: 10px; margin-top: 8px"></span>
				</div>
				<span class="ld-sk ld-sk-cover ld-sk-cover-lg"></span>
			</div>
			<div class="ld-sk-landing-split">
				<div class="ld-sk-card-body">
					<span class="ld-sk" style="width: 32%; height: 10px"></span>
					<span class="ld-sk" style="width: 68%; height: 18px; margin-top: 10px"></span>
					<span class="ld-sk" style="width: 88%; height: 10px; margin-top: 12px"></span>
				</div>
				<span class="ld-sk ld-sk-cover ld-sk-cover-lg"></span>
			</div>
			<div class="ld-sk-grid ld-sk-landing-compact">
				<div class="ld-sk-card" v-for="n in 4" :key="'lt-' + n">
					<span class="ld-sk ld-sk-cover"></span>
					<div class="ld-sk-card-body">
						<span class="ld-sk" style="width: 52%; height: 14px"></span>
						<span class="ld-sk" style="width: 86%; height: 10px; margin-top: 10px"></span>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'LdSkeleton',
	props: {
		variant: {
			type: String,
			default: 'list'
		},
		count: {
			type: Number,
			default: 6
		},
		withHero: {
			type: Boolean,
			default: false
		},
		withAvatar: {
			type: Boolean,
			default: false
		},
		withList: {
			type: Boolean,
			default: true
		},
		withChart: {
			type: Boolean,
			default: true
		},
		withCta: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		klineBarCount() {
			return 22
		}
	},
	methods: {
		rowTitleWidth(n) {
			const widths = [48, 62, 40, 55, 70, 44]
			return widths[(n - 1) % widths.length] + '%'
		},
		rowSubWidth(n) {
			const widths = [32, 28, 38, 24, 34, 30]
			return widths[(n - 1) % widths.length] + '%'
		},
		chatWidth(n) {
			const widths = [56, 42, 68, 50, 38, 60]
			return widths[(n - 1) % widths.length] + '%'
		},
		klinePick(list, n) {
			return list[(n - 1) % list.length]
		},
		klineColStyle(n) {
			const heights = [46, 62, 38, 70, 52, 78, 44, 60, 74, 48, 66, 40, 72, 54, 50, 68, 36, 64, 76, 42, 58, 52]
			return { '--ld-sk-kline-h': this.klinePick(heights, n) + '%' }
		},
		klineBodyStyle(n) {
			const bodies = [36, 48, 28, 54, 40, 60, 32, 46, 56, 34, 50, 30, 58, 42, 38, 52, 26, 48, 62, 34, 44, 40]
			return { '--ld-sk-kline-body': this.klinePick(bodies, n) + '%' }
		},
		klineVolStyle(n) {
			const vols = [40, 72, 28, 88, 50, 64, 36, 80, 44, 58, 70, 32, 84, 48, 60, 76, 24, 68, 90, 42, 54, 66]
			return { height: this.klinePick(vols, n) + '%' }
		}
	}
}
</script>

<style lang="scss" scoped>
.ld-skeleton {
	width: 100%;
	pointer-events: none;
}

.ld-sk-hero {
	margin-bottom: 20px;
}

.ld-sk-title {
	width: 180px;
	height: 32px;
	border-radius: 8px;
}

.ld-sk-subtitle {
	width: 260px;
	max-width: 80%;
	height: 14px;
	margin-top: 10px;
	border-radius: 6px;
}

.ld-sk-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 12px;
}

.ld-sk-card {
	border: 1px solid var(--ld-border, #ececec);
	border-radius: 16px;
	overflow: hidden;
	background: var(--ld-bg-card, #fff);
}

.ld-sk-cover {
	width: 100%;
	height: 140px;
	border-radius: 0;
}

.ld-sk-card-body {
	padding: 14px 16px 16px;
}

.ld-sk-btn {
	display: block;
	width: 100%;
	height: 36px;
	margin-top: 14px;
	border-radius: 999px;
}

.ld-sk-list,
.ld-sk-table {
	display: flex;
	flex-direction: column;
}

.ld-sk-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 14px 0;
	border-bottom: 1px solid var(--ld-border, #ececec);
}

.ld-sk-row:last-child {
	border-bottom: none;
}

.ld-sk-row-text {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
}

.ld-sk-circle {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	flex-shrink: 0;
}

.ld-sk-circle.lg {
	width: 48px;
	height: 48px;
}

.ld-sk-thead,
.ld-sk-trow {
	display: grid;
	grid-template-columns: 1.4fr 0.8fr 1fr 0.7fr;
	align-items: center;
	gap: 12px;
	padding: 14px 16px;
}

.ld-sk-thead {
	background: var(--ld-bg-muted, #f7f7f7);
	border-radius: 16px 16px 0 0;
}

.ld-sk-table {
	border: 1px solid var(--ld-border, #ececec);
	border-radius: 16px;
	overflow: hidden;
}

.ld-sk-trow {
	border-top: 1px solid var(--ld-border, #ececec);
}

.ld-sk-asset {
	display: flex;
	align-items: center;
	gap: 10px;
}

.ld-sk-card-block {
	border: 1px solid var(--ld-border, #ececec);
	border-radius: 16px;
	padding: 16px;
	background: var(--ld-bg-card, #fff);
	margin-bottom: 12px;
}

.ld-sk-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.ld-sk-chip {
	width: 64px;
	height: 32px;
	border-radius: 999px;
}

.ld-sk-cta {
	display: block;
	width: 100%;
	height: 48px;
	margin-top: 20px;
	border-radius: 999px;
}

.ld-sk-actions {
	display: flex;
	gap: 12px;
	margin-top: 16px;
}

.ld-sk-hero-row {
	display: flex;
	align-items: center;
	gap: 12px;
}

.ld-sk-metrics {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	margin: 20px 0;
}

.ld-sk-metric {
	border: 1px solid var(--ld-border, #ececec);
	border-radius: 16px;
	padding: 14px;
	display: flex;
	flex-direction: column;
}

.ld-sk-stat-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-top: 16px;
}

.ld-sk-featured {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	margin: 16px 0;
}

.ld-sk-feat-card {
	border: 1px solid var(--ld-border, #ececec);
	border-radius: 16px;
	padding: 16px;
	background: var(--ld-bg-card, #fff);
}

.ld-sk-chat {
	display: flex;
	margin-bottom: 12px;
}

.ld-sk-chat.mine {
	justify-content: flex-end;
}

.ld-sk-bubble {
	height: 40px;
	border-radius: 16px;
	max-width: 80%;
}

.ld-sk-landing-hero {
	display: grid;
	grid-template-columns: 1.1fr 0.9fr;
	gap: 24px;
	align-items: center;
}

.ld-sk-visual {
	width: 100%;
	height: 280px;
	border-radius: 20px;
}

.ld-sk-landing-stats {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 12px;
	margin-top: 28px;
}

.ld-sk-landing-featured {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
	margin-top: 28px;
}

.ld-sk-landing-compact {
	margin-top: 12px;
}

.ld-sk-landing-markets {
	margin-top: 12px;
	grid-template-columns: 1fr 1fr;
}

.ld-sk-landing-split {
	display: grid;
	grid-template-columns: 1.08fr 0.92fr;
	gap: 16px;
	align-items: center;
	margin-top: 28px;
}

.ld-sk-cover-lg {
	height: 168px;
}

.ld-sk-trade-crumb {
	display: flex;
	align-items: center;
	gap: 6px;
	margin-bottom: 18px;
}

.ld-sk-trade-asset {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 16px;
}

.ld-sk-trade-asset .ld-sk-hero-row {
	flex: 1;
	min-width: 0;
}

.ld-sk-trade-logo {
	width: 44px;
	height: 44px;
}

.ld-sk-trade-collect {
	width: 48px;
	height: 48px;
	margin-left: auto;
	flex-shrink: 0;
}

.ld-sk-trade-price {
	display: flex;
	align-items: baseline;
	gap: 12px;
}

.ld-sk-trade-layout {
	display: grid;
	grid-template-columns: minmax(0, 1fr) 360px;
	gap: 20px;
	align-items: start;
	margin-top: 20px;
}

.ld-sk-trade-chart,
.ld-sk-trade-form {
	margin-bottom: 0;
	border-radius: 20px;
	padding: 16px;
}

.ld-sk-trade-chart {
	padding: 0;
}

.ld-sk-trade-chart .ld-sk-chips {
	padding: 16px 16px 12px;
}

.ld-sk-trade-chip {
	width: 52px;
	height: 36px;
}

.ld-sk-trade-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	min-height: 36px;
	margin-bottom: 12px;
}

.ld-sk-trade-lev-pill {
	width: 56px;
	height: 32px;
	border-radius: 999px;
	flex-shrink: 0;
}

.ld-sk-trade-kline {
	width: 100%;
	height: 420px;
	margin-top: 0;
}

.ld-sk-trade-kline .ld-skeleton {
	height: 100%;
}

.ld-skeleton.is-kline {
	height: 100%;
	min-height: 0;
}

.ld-sk-kline {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 240px;
	padding: 12px 10px 10px 8px;
	box-sizing: border-box;
}

.ld-sk-kline-plot {
	flex: 1;
	display: flex;
	min-height: 0;
	gap: 8px;
}

.ld-sk-kline-candles {
	flex: 1;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 3px;
	min-width: 0;
}

.ld-sk-kline-col {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	height: var(--ld-sk-kline-h, 50%);
	min-width: 0;
}

.ld-sk-kline-wick {
	width: 2px;
	flex: 1;
	min-height: 8px;
	border-radius: 1px;
}

.ld-sk-kline-body {
	width: 70%;
	max-width: 9px;
	height: var(--ld-sk-kline-body, 40%);
	min-height: 10px;
	border-radius: 2px;
	flex-shrink: 0;
}

.ld-sk-kline-axis {
	width: 40px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 4px 0;
}

.ld-sk-kline-axis .ld-sk {
	width: 28px;
	height: 8px;
	margin-left: auto;
}

.ld-sk-kline-vol {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 3px;
	height: 18%;
	min-height: 36px;
	margin-top: 8px;
	padding-right: 48px;
}

.ld-sk-kline-vol-bar {
	flex: 1;
	border-radius: 2px;
}

.ld-sk-trade-seg {
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	gap: 4px;
	margin-bottom: 16px;
	padding: 4px;
	border-radius: 14px;
	background: var(--ld-bg-muted, #f7f7f7);
}

.ld-sk-trade-seg-item {
	height: 40px;
	border-radius: 11px;
}

.ld-sk-trade-tabs {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 0;
}

.ld-sk-trade-tabs--sub {
	margin-bottom: 0;
}

.ld-sk-trade-field {
	display: block;
	width: 100%;
	height: 52px;
	margin-top: 8px;
	border-radius: 14px;
}

.ld-sk-trade-switch {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 12px;
	min-height: 28px;
}

.ld-sk-trade-switch-track {
	width: 44px;
	height: 26px;
	border-radius: 999px;
}

.ld-sk-trade-meta {
	margin-top: 4px;
}

.ld-sk-trade-actions {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-top: 4px;
}

.ld-sk-trade-action {
	height: 54px;
	margin-top: 0;
	width: 100%;
	border-radius: 14px;
}

.is-sheet {
	padding: 8px 0;
}

@media (max-width: 900px) {
	.ld-sk-grid {
		grid-template-columns: repeat(2, 1fr);
	}

	.ld-sk-featured,
	.ld-sk-landing-hero,
	.ld-sk-landing-featured,
	.ld-sk-landing-split,
	.ld-sk-metrics,
	.ld-sk-stat-grid {
		grid-template-columns: 1fr;
	}

	.ld-sk-landing-stats {
		grid-template-columns: 1fr 1fr;
	}

	.ld-sk-thead,
	.ld-sk-trow {
		grid-template-columns: 1.4fr 0.8fr 1fr;
	}

	.ld-sk-visual {
		height: 180px;
	}

	.ld-sk-cover {
		height: 110px;
	}
}
</style>
